export function headerNav(){
    let isMobile = !!document.querySelector('body.mobile');
    window.addEventListener('resize', onNavBarResize)
    setTimeout(onNavBarResize, 1)
  
    function onNavBarResize(){
      isMobile = !!document.querySelector('body.mobile');
      if(!isMobile) return;
  
      const border = document.querySelector('#masthead table');
      border?.remove()
      const div = document.createElement('div');
      div.classList.add('navbar-border')  
      const innerdiv = document.createElement('div');
      innerdiv.classList.add('inner');
      div.append(innerdiv)
      const globalNav = document.querySelector('#globalNav');
      globalNav?.append(div)
      div.style.width = globalNav?.scrollWidth + 'px';
    }
  }